var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Element from './Element';
import Path2D from '../geometry/Path2D';
var Shape = /** @class */ (function (_super) {
    __extends(Shape, _super);
    function Shape() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.svgTagName = 'path';
        return _this;
    }
    Shape.prototype.brush = function (ctx) {
        ctx;
    };
    Shape.prototype.getSvgAttributes = function () {
        var ret = _super.prototype.getSvgAttributes.call(this);
        if ((this.fillAble || this.strokeAble) && this.type !== 'text' && this.type !== 'use') {
            var path = this.getPathData();
            ret.d = path.getSVGPathString();
        }
        return ret;
    };
    Shape.prototype.getPathData = function () {
        var path = new Path2D();
        this.brush(path);
        return path;
    };
    Shape.prototype.getTotalLength = function () {
        return this.getPathData().getTotalLength();
    };
    Shape.prototype.getPointAtLength = function (len) {
        return this.getPathData().getPointAtLength(len);
    };
    Shape.prototype.getPoint = function (ration) {
        return this.getPathData().getPointAtPercent(ration);
    };
    return Shape;
}(Element));
export default Shape;
